import React, { useState, useEffect, useCallback } from "react";
import { Row, Col } from "antd";

import StaticStats from "./static-stats";
import ProductsTable from "./product-table";
import { getDashboardStats, getDashboardStockAlerts } from "../../../_redux/dashboard/dashboardCrud";
import { isEqual, isFunction } from "lodash";
import { dateStringApplyOffSet, getSettingKey, handleApiErrorResponse } from "../../../../Common/utils";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment-timezone";

// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
export default function ({ dashboardFilters, searchChannelsEntities }) {
  const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
  const { entity } = currentState;
  const timezone = getSettingKey(entity, "Basic", "timezone");
  const defaultSorted = [{ dataField: "id", order: "asc" }];
  const initialFilter = {
    searchKey: "",
    sortOrder: "desc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 20,
    channel_ids: []
  };

  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);
  const [stocks, setStocks] = useState({});
  const [stats, setStats] = useState({
    stock_alerts: [],
    total_brands: 0,
    total_categories: 0,
    total_customers: 0,
    total_stock_cost: 0,
    total_products: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchDashboardAlerts = async () => {
    try {
      let newParams = {
        ...queryParams,
        search_key: queryParams?.searchKey,
        page: queryParams?.pageNumber,
        page_size: queryParams?.pageSize,
        start_date: dateStringApplyOffSet(moment(queryParams?.start_date).format("YYYY-MM-DD"), timezone),
        end_date: dateStringApplyOffSet(moment(queryParams?.end_date).format("YYYY-MM-DD"), timezone),
        channel_ids: searchChannelsEntities.length == queryParams?.channel_ids?.length ? "" : queryParams.channel_ids.join(",")
        // sort_field: queryParams?.sortField,
        // sort_order: queryParams?.sortOrder,
      };

      delete newParams?.searchKey;
      delete newParams?.pageNumber;
      delete newParams?.pageSize;
      delete newParams?.sortField;
      delete newParams?.sortOrder;
      setLoading(true);

      const { data } = await getDashboardStockAlerts(newParams);
      setStocks(data);
    } catch (err) {
      handleApiErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };
  const fetchStats = async () => {
    try {
      setLoading(true);
      const { start_date, end_date } = dashboardFilters;
      const temp_start_date = dateStringApplyOffSet(moment(start_date).format("YYYY-MM-DD"), timezone);
      const temp_end_date = dateStringApplyOffSet(moment(end_date).format("YYYY-MM-DD"), timezone);
      const params = { start_date: temp_start_date, end_date: temp_end_date,  channel_ids: searchChannelsEntities.length == queryParams?.channel_ids?.length ? "" : queryParams.channel_ids.join(",") };
      const { data } = await getDashboardStats(params);
      setStats(data);
    } catch (err) {
      handleApiErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dashboardFilters?.channel_ids?.length) {
      fetchStats();
      fetchDashboardAlerts();
    }
  }, [queryParams]);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...dashboardFilters });
  }, [dashboardFilters]);

  return (
    <Row gutter={[0, 25]}>
      <Col span={24}>
        <StaticStats loading={loading} stats={stats} />
      </Col>
      <Col span={24}>
        <ProductsTable stocks={stocks} setQueryParams={setQueryParams} queryParams={queryParams} loading={loading} stats={stats} />
      </Col>
    </Row>
  );
}
